<script setup lang="ts">
import { ref } from 'vue'
import { SlickItem, SlickList } from 'vue-slicksort'
import Item from './Item.vue'
import { IconFont } from '@mp/component'

const visible = ref<boolean>(false)
const defaultMenus = ref([
  { id: 1, name: '交易订单管理' },
  { id: 2, name: '交易订单管理' },
  { id: 3, name: '交易订单管理' },
  { id: 4, name: '交易订单管理' },
  { id: 5, name: '交易订单管理' },
  { id: 6, name: '交易订单管理' },
  { id: 7, name: '交易订单管理' },
  { id: 8, name: '交易订单管理' },
  { id: 9, name: '交易订单管理' },
  { id: 10, name: '交易订单管理' },
])

function handleClose() {
  visible.value = false
}

defineExpose({
  open() {
    visible.value = true
  },
})
</script>

<template>
  <el-drawer v-model="visible" append-to-body :size="720" :show-close="false" style="--el-drawer-bg-color: #F5F7FA">
    <template #header>
      <div
        class="bg-white p-4 -mx-[calc(var(--el-drawer-padding-primary))] -mt-[calc(var(--el-drawer-padding-primary))] -mb-[30px]"
      >
        <h3 class="text-lg text-black font-bold flex justify-between items-center">
          常用功能设置
          <IconFont type="icon-close-outline" class="text-2xl cursor-pointer" @click="handleClose" />
        </h3>

        <div class="text-black text-sm flex items-center mt-3">
          已添加 <span class="text-n-90">可拖动排序，最多支持添加12项，最少添加1项</span>

          <el-button type="primary" link class="ml-auto">
            清空
          </el-button>
        </div>

        <el-empty description="请添加常用功能" />

        <SlickList
          v-model:list="defaultMenus" helper-class="slick-helper" axis="xy"
          class="flex flex-wrap text-sm mt-6 select-none"
        >
          <SlickItem v-for="(item, index) in defaultMenus" :key="item" class="slick-item" :index="index">
            <Item :label="item.name" />
            <IconFont
              type="icon-jianhao"
              class=" absolute -right-2 -top-3 text-lg text-n-90 cursor-pointer active:scale-95" @click.stop
            />
          </SlickItem>
        </SlickList>
      </div>
    </template>

    <template #footer>
      <div
        class="bg-white p-4 -mx-[calc(var(--el-drawer-padding-primary))] -mb-[calc(var(--el-drawer-padding-primary))] -mt-[10px] border-t border-t-solid border-t-n-40"
      >
        <el-button bg text>
          取消
        </el-button>
        <el-button type="primary">
          确定
        </el-button>
      </div>
    </template>

    <section class="py-4 space-y-4">
      <div v-for="item in 50" :key="item" class="bg-white rounded-md p-4">
        <label class="block text-black text-base font-bold">运营中心</label>

        <div v-for="i in 10" :key="i">
          <label class="block mt-6 mb-3 text-sm">门店管理</label>
          <div class="flex flex-wrap text-sm">
            <Item v-for="j in 10" :key="j" label="交易订单管理" class="mr-3 mb-2" />
          </div>
        </div>
      </div>
    </section>
  </el-drawer>
</template>

<style scoped>
.slick-item {
  @apply relative z-[9999] border border-solid border-transparent mr-3 mb-2 rounded-md;
}

.slick-helper.slick-item {
  @apply shadow-xl border-primary;
}
</style>
